import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight, FiCalendar, FiClock, FiUser } from 'react-icons/fi';
import SeoHead from '../components/SeoHead';
import { useContent } from '../context/ContentContext';
import './WebinarsPage.css';

const WebinarsPage = () => {
  const { webinars, ready } = useContent();
  const upcoming = webinars.filter((w) => w.status !== 'past');
  const past = webinars.filter((w) => w.status === 'past');

  return (
    <>
      <SeoHead title="Webinars" description="Join THINKINGWORLD live sessions on web, mobile, IoT, SEO and digital marketing — with Q&amp;A." path="/resources/webinars" />

      <header className="page-header">
        <div className="container">
          <span className="section-eyebrow">Webinars</span>
          <h1>Live sessions with Q&amp;A.</h1>
          <p>45-minute live webinars on the topics our clients ask about most. Free, no sales pitch.</p>
        </div>
      </header>

      <section className="section">
        <div className="container">
          <h2 className="webinars-h">Upcoming</h2>
          {!ready && <p className="webinars-empty">Loading…</p>}
          {ready && upcoming.length === 0 && (
            <p className="webinars-empty">No upcoming webinars right now — check back soon.</p>
          )}
          <div className="webinars-grid">
            {upcoming.map((w) => (
              <article key={w.id} className="webinar-card">
                <span className="webinar-status webinar-status--up">Upcoming</span>
                <h3>{w.title}</h3>
                <p>{w.description}</p>
                <div className="webinar-meta">
                  {w.speaker && <span><FiUser /> {w.speaker}</span>}
                  <span><FiCalendar /> {w.date}</span>
                  {w.time && <span><FiClock /> {w.time}</span>}
                </div>
                <Link to={w.registerUrl || '/contact'} className="btn btn-accent webinar-cta">
                  Register <FiArrowRight />
                </Link>
              </article>
            ))}
          </div>

          {past.length > 0 && (
            <>
              <h2 className="webinars-h webinars-h--past">Past sessions</h2>
              <div className="webinars-grid">
                {past.map((w) => (
                  <article key={w.id} className="webinar-card webinar-card--past">
                    <span className="webinar-status">Recorded</span>
                    <h3>{w.title}</h3>
                    <p>{w.description}</p>
                    <div className="webinar-meta">
                      {w.speaker && <span><FiUser /> {w.speaker}</span>}
                      <span><FiCalendar /> {w.date}</span>
                    </div>
                    <Link to={w.registerUrl || '/resources/videos'} className="btn btn-ghost webinar-cta">
                      Watch recording <FiArrowRight />
                    </Link>
                  </article>
                ))}
              </div>
            </>
          )}
        </div>
      </section>
    </>
  );
};

export default WebinarsPage;
